import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './apontamentoForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

import { 
	setModoTela, initForm, salvar, excluir, getLista, 
	getListaTipo, getListaGrupo, getListaMotorista, getListaVeiculo 
} from './apontamentoActions';
import LabelAndInputMask from '../common/form/labelAndInputMask';

class Apontamento extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		dataInicial: DateFormat.formatarDataSqlParaTela(DateFormat.getTimestampParaData(new Date().getTime() - 604800000)),
		dataFinal: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTipo();
		this.props.getListaGrupo();
		this.props.getListaMotorista();
		this.props.getListaVeiculo();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', { data_apontamento: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()) });
									this.props.initForm({ data_apontamento: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()) });
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Row>
						<LabelAndInputMask
							name='data_inicial'
							label='Data Inicial' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							value={this.state.dataInicial}
							onChange={data => {
								this.setState({
									...this.state,
									dataInicial: data.target.value
								});
							}} />

						<LabelAndInputMask
							name='data_final'
							label='Data Final' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							value={this.state.dataFinal}
							onChange={data => {
								this.setState({
									...this.state,
									dataFinal: data.target.value
								});
							}} />
					</Row>
					
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1}>Data</Th>
								<Th colspan={1}>Tipo</Th>
								<Th colspan={1}>Motorista</Th>
								<Th colspan={1}>Veículo</Th>
								<Th colspan={1} alignCenter>Pontos</Th>
								<Th colspan={1}></Th>								
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`
										${DateFormat.formatarDataSqlParaTela(item.data_apontamento)}
										${item.nome_tipo}
										${item.nome_motorista}
										${item.placa_veiculo}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}

								if (this.state.dataInicial
									&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_apontamento)) < DateFormat.formatarDataTelaParaSql(this.state.dataInicial)) {
									return false;
								}
								if (this.state.dataFinal
									&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_apontamento)) > DateFormat.formatarDataTelaParaSql(this.state.dataFinal)) {
									return false;
								}

								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{DateFormat.formatarDataSqlParaTela(item.data_apontamento)}</Td>
									<Td>{item.nome_tipo}</Td>
									<Td>{item.nome_motorista}</Td>
									<Td>{item.placa_veiculo}</Td>
									<Td alignCenter>{FormatUtils.formatarValorTela(item.pontos, 0)}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													data_apontamento: DateFormat.formatarDataSqlParaTela(item.data_apontamento)
												});
												this.props.initForm({
													...item,
													data_apontamento: DateFormat.formatarDataSqlParaTela(item.data_apontamento)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													data_apontamento: DateFormat.formatarDataSqlParaTela(item.data_apontamento)
												});
												this.props.initForm({
													...item,
													data_apontamento: DateFormat.formatarDataSqlParaTela(item.data_apontamento)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.apontamento,
	modoTela: state.apontamento.modoTela,
	lista: state.apontamento.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, 
	getListaTipo, getListaGrupo, getListaMotorista, getListaVeiculo 
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Apontamento);
